module.exports = __webpack_public_path__ + "img/popup_2026_06_04.a9ff5077.jpeg";